import { generateImageProps, resolveImageUrl } from "../functions/cms"
import s from "./ImgWithFallbackInMarkdown.module.css"

const ImgWithFallbackInMarkdown = (props) => {
  const { src, marginTopBottom } = props
  const directEndpoint = (process.env.REACT_APP_DIRECT_ENDPOINT || "").trim()
  const imageProps = generateImageProps(src)

  const cleanFileName = imageProps.fileName.slice(
    0,
    imageProps.fileName.lastIndexOf("."),
  )

  return (
    <div className={marginTopBottom ? s.wrapper : ""}>
      <picture>
        {directEndpoint && (
          <source
            srcSet={resolveImageUrl(
              imageProps.folder + "_webp/" + cleanFileName + "/original.webp",
            )}
            type="image/webp"
            alt={props.alt}
          />
        )}
        <img
          srcSet={resolveImageUrl(imageProps.folder + imageProps.fileName)}
          alt={props.alt}
          {...props}
        />
      </picture>
    </div>
  )
}

export default ImgWithFallbackInMarkdown
